import axios from "axios";

import { FormPayload } from "../models/form-payload";
import { GenericFormUrlArgs, getFormUrl, SupplierFormUrlArgs } from "./getFormUrl";

interface PayloadArgs {
  data: FormPayload;
  token?: string;
}

interface GenericPostArgs extends PayloadArgs, GenericFormUrlArgs {}
interface SupplierPostArgs extends PayloadArgs, SupplierFormUrlArgs {}

type PostArgs = GenericPostArgs | SupplierPostArgs;

// Some fields are compatible with a certain payload and not with others
// so they have to be filtered or adapted from the general payload structure
export const sendForm = async (args: PostArgs) => {
  if (args.type === "leads") {
    await axios.post(
      getFormUrl(),
      {
        ...args.data,
        gRecaptchaResponse: args.token,
        leadSource: "Business Web Site",
        locale: undefined,
        businessRole: undefined,
      },
      {
        headers: {
          "client-id": process.env.GATSBY_MULE_CLIENT_ID,
          "client-secret": process.env.GATSBY_MULE_CLIENT_SECRET,
        },
      }
    );
  } else if (args.type === "catalogs") {
    await axios.post(getFormUrl({ type: args.type, catalogId: args.catalogId }), {
      ...args.data,
      gRecaptchaResponse: args.token,
      materials: undefined,
      businessRole: undefined,
      leadSource: "Business Web Site",
      requestTitle: `Download catalog`,
    });
  } else {
    await axios.post(getFormUrl({ type: args.type }), {
      ...args.data,
      gRecaptchaResponse: args.token,
      requestMessage: undefined,
      requestTitle: undefined,
      materials: undefined,
      message: args.data.requestMessage,
    });
  }
};
